import React, { useState } from "react";
import {
    Modal,
    Box,
    TextField,
    Typography,
    Stack,
    IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "@mui/joy";
import CloseIcon from "@mui/icons-material/Close";
import { networkUrls } from "../../services/networkurls";
import { Delete, Post, Put } from "../../services/apiServices";
import { set } from "lodash";
import "./CertificationModal.css";
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
};

const CertificationModal = ({ open, setOpen, type, setIsShowSnackbar, setSnackbarInfo, setTrigegerGetCall, data }: any) => {
    const [loading, setLoading] = useState(false);
    const ButtonText = type === "add" ? "Add" : type === "edit" ? "Update" : "Delete";

    const handleClose = () => setOpen(false);

    const validationSchema = Yup.object({
        certificate: Yup.string()
            .required("Certificate name is required")
            .min(3, "Must be at least 3 characters"),
        count: Yup.number()
            .required("Count is required")
            .positive("Count must be positive")
            .integer("Count must be an integer"),
    });

    const formik: any = useFormik({
        initialValues: {
            certificate: type === "edit" ? data?.certification_name : "",
            count: type === "edit" ? data?.count : "",
        },
        validationSchema : type === "delete" ? null : validationSchema,
        onSubmit: (values) => {
            if (type === "add") {
                addCertification(values);
            } else if (type === "edit") {
                editCertification(values);
            } else {
                handleDelete()
            }

        },
    });


    const addCertification = async (values: any) => {
        setLoading(true);

        const payload = {
            certification_name: values.certificate,
            count: values.count,

        };

        try {

            const response: any = await Post(networkUrls.addCertification, payload, true);
            if (response.status === 200) {
                setTrigegerGetCall((prev: any) => prev + 1);
                setIsShowSnackbar(true);
                setSnackbarInfo({
                    color: "success",
                    message: response?.data?.message
                })

            } else {
                setIsShowSnackbar(true);
                setSnackbarInfo({
                    color: "error",
                    message: response?.data?.error || "Adding certification failed"
                })
            }

        } catch (err) {
            console.log("Error adding certification:", err);
        }
        finally {
            setLoading(false);
            handleClose();
        }
    }

    const handleDelete = async() => {
        console.log("Deleting certification with ID:", data);
        setLoading(true);
        try{
            const response: any = await Delete(`${networkUrls.deleteCertification}/${data.certificate_id}`, true);
            if (response.status === 200) {
                setTrigegerGetCall((prev: any) => prev + 1);
                setIsShowSnackbar(true);
                setSnackbarInfo({
                    color: "success",
                    message: response?.data?.message
                })  
        }else{
            setIsShowSnackbar(true);
            setSnackbarInfo({
                color: "error",
                message: response?.data?.error || "Deleting certification failed"
            })
        }
    } catch(err){
        console.log("Error deleting certification:", err);
        
    }
    finally{
        handleClose();
        setLoading(false);
    }
}
    const editCertification = async (values: any) => {
        setLoading(true);
        const payload = {
            certification_name: values.certificate,
            count: values.count,
            certification_id: data.certificate_id

        };
        try {

            const response: any = await Put(`${networkUrls.updateCertification}`, payload, true);
            console.log("response in add", response);
            if (response.status === 200) {
                setTrigegerGetCall((prev: any) => prev + 1);
                setIsShowSnackbar(true);
                setSnackbarInfo({
                    color: "success",
                    message: response?.response?.message
                })
            } else {
                setIsShowSnackbar(true);
                setSnackbarInfo({
                    color: "error",
                    message: response?.data?.error || "Updating certification failed"
                })

            }

        } catch (err) {
            console.log("Error updating certification:", err);
        }
        finally {
            setLoading(false);
            handleClose();
        }
    }

    return (
        <div>

            <Modal open={open} onClose={handleClose}>
                <Box sx={style} component="form" onSubmit={formik.handleSubmit} className="certification-modal-container">
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "grey.600",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {type === "delete" ? (<>
                        <Typography variant="h6" mb={2}>
                            Are you sure you want to delete this certification?
                        </Typography>
                    </>) :
                        <>
                            <Typography variant="h6" mb={2}>
                                {type === "add" ? "Add" : "Edit"} {"Certificate"}
                            </Typography>
                            <Stack spacing={2}>
                                <TextField
                                    fullWidth
                                    id="certificate"
                                    name="certificate"
                                    label="Certificate Name"
                                    value={formik.values.certificate}
                                    autoComplete="off"
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.certificate && Boolean(formik.errors.certificate)
                                    }
                                    helperText={formik.touched.certificate && formik.errors.certificate}
                                />

                                <TextField
                                    fullWidth
                                    id="count"
                                    name="count"
                                    label="Count"
                                    type="number"
                                    value={formik.values.count}
                                    onChange={formik.handleChange}
                                    error={formik.touched.count && Boolean(formik.errors.count)}
                                    helperText={formik.touched.count && formik.errors.count}
                                />


                            </Stack>


                        </>
                    }

                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                        <Button variant="outlined" color="neutral" onClick={() => setOpen(false)} type="button">
                            Cancel
                        </Button>
                        <Button type="submit" variant="solid" sx={{ backgroundColor: "#4D8FAC" }} loading={loading}>
                            {ButtonText}
                        </Button>
                    </Stack>

                </Box>
            </Modal>
        </div>
    );
};

export default CertificationModal;
